export default __webpack_public_path__ + "static/media/diablos_rojos.252f5c38.png";